export const getImageForRating = (rating: number) => {
  switch (rating) {
    case 0:
      return `/img/yelp-stars/regular_0.png`
    case 1:
      return `/img/yelp-stars/regular_1.png`
    case 1.5:
      return `/img/yelp-stars/regular_1_half.png`
    case 2:
      return `/img/yelp-stars/regular_2.png`
    case 2.5:
      return `/img/yelp-stars/regular_2_half.png`
    case 3:
      return `/img/yelp-stars/regular_3.png`
    case 3.5:
      return `/img/yelp-stars/regular_3_half.png`
    case 4:
      return `/img/yelp-stars/regular_4.png`
    case 4.5:
      return `/img/yelp-stars/regular_4_half.png`
    case 5:
      return `/img/yelp-stars/regular_5.png`
    default:
      return `/img/yelp-stars/regular_5.png`
  }
}
